import { useState } from "react"
import Loading from "../../Loading"
import Error from "../../components/Error"
import useDBO from "../../hooks/useDBO"
import DrawContact from "./DrawContact"
import Pagination from "../../components/Pagination"
import Rating from "../../components/Rating"
import { Button } from "@mui/material"

export default function AllLeads() {
    const [score, setScore] = useState(5)
    const leads = useDBO(`/marketing-leads/${score}`)
    const [page,setPage] = useState(0)

    if (leads.loading) return <Loading />
    if (leads.error) return <Error />

    return (
      <div style={{ display: "flex", flexDirection: "column" }}>
        <div>
          <div style={{display:"flex", gap:10}}>
            <Rating
              value={score}
              setValue={setScore}
                    />
            <Button onClick={()=>setScore(0)}>No rating</Button>
          </div>
          <Pagination
            page={page}
            setPage={setPage}
            end={leads.get.length}
          />
        </div>
        <div>
          {leads.get.slice(page * 10, page * 10 + 10).map((l) => (
            <DrawContact
              contact={l}
              showResult
              showRating
              key={l._id}
            />
          ))}
        </div>
      </div>
    );
}